<template>
	<!-- 首页二级 标签导航 -->
	<div class="bpBox">
		<div class="biaoqianTitle">
			<h4>热门类型</h4>
			<img src="../../assets/img/rightarr_pink.png" alt="">
		</div>
		<div class="hotTypeBoxfather">
			<div class="hotTypeBox">
				<div class="hotTypeItem" v-for="(item,index) in type_list" @click="keywordsFn(item.title)">
					<div class="hotTypeItem_img">
						<img :src="item.imgUrl" alt="">
					</div>
					<p class="hotTypeItem_txt">{{item.title}}</p>
				</div>
			</div>
		</div>
		<div class="biaoqianTitle">
			<h4>热门标签</h4>
			<img src="../../assets/img/rightarr_pink.png" alt="">
		</div>
		<!-- 热门标签按钮 -->
		<div class="biaoqianList">
			<button v-for='item in hot_lable_list' @click="keywordsFn(item.name,item.id)">{{item.name}}</button>

		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				bp_swiperOption: {
					slidesPerView: 5,
					slidesPerColumn: 2,
					spaceBetween: 0,
					paginationClickable: false,
					freeMode: false
				},
				type_list: [{
						title: '爱情',
						imgUrl: require('../../assets/img/bq_aiqing.png')
					},
					{
						title: '武侠',
						imgUrl: require('../../assets/img/bq_wx.png')
					},
					{
						title: '剧情',
						imgUrl: require('../../assets/img/bq_jq.png')
					},
					{
						title: '游戏',
						imgUrl: require('../../assets/img/bq_yx.png')
					},
					{
						title: '悬疑',
						imgUrl: require('../../assets/img/bq_xy.png')
					},
					{
						title: '玄幻仙侠',
						imgUrl: require('../../assets/img/bq_xhxx.png')
					},
					{
						title: '奇幻传奇',
						imgUrl: require('../../assets/img/bq_qhcq.png')
					},
					{
						title: '古典衍生',
						imgUrl: require('../../assets/img/bq_gdys.png')
					},
					{
						title: '东方衍生',
						imgUrl: require('../../assets/img/bq_dfys.png')
					},
					{
						title: '西方衍生',
						imgUrl: require('../../assets/img/bq_xfys.png')
					},
				],
				hot_lable_list: {}
			}
		},
		created() {
			this.get_hot_lable_list()
		},
		methods: {
			// 热门标签
			get_hot_lable_list() {
				this.$axios.post(this.$api.hot_lable_list).then(res => {
					if (res.status == 200) {
						console.log(res, '热门标签')
						this.hot_lable_list = res.data.data
					}
				})
			},
			// 关键字
			keywordsFn(word, id) {
				console.log(word);
				this.$router.push({
					path: '/searchResult',
					query: {
						keywordHost: word,
						id: this.id,
						getSecond_tab: 5,
						getFirstvalue_tab: 0,
						url: 'biaoqian',
						labelId: id
					}
				})
			}
		},
	}
</script>

<style lang="less" scoped>
	.bpBox {
		overflow-x: hidden;
		background-color: #fff;
		padding-top: 60px;
		overflow-y: scroll;
		height: calc(100vh - 220px);

		// 标题
		.biaoqianTitle {
			position: relative;
			background-color: #fff;
			padding: 0 16px;

			h4 {
				color: #ff4081;
				padding: 20px 0;
				line-height: 40px;
				font-size: 30px;
				/*px*/
				font-weight: 700;
			}

			img {
				position: absolute;
				top: 50%;
				right: 10px;
				transform: translateY(-50%);
				width: 40px;
			}
		}

		.hotTypeBoxfather {
			background-color: #fff;
			border-bottom: 5px solid #f0f0f0;

			/*no*/
			.hotTypeBox {
				overflow: hidden;
				margin: 0 16px;

				.hotTypeItem {
					width: calc((100vw - 72px) / 5);
					float: left;
					padding-right: 10px;
					margin-bottom: 20px;
					text-align: center;

					.hotTypeItem_img:nth-child(1) {
						img {
							width: 80%;
							margin: 0 auto;
						}
					}

					.hotTypeItem_txt {
						text-align: center;
						color: #1f1f1f;
						font-size: 30px;
						/*px*/
					}
				}

				.hotTypeItem:nth-child(5n) {
					padding-right: 0;
				}
			}

		}


		//轮播
		// .hotType_swiper {
		// 	margin-bottom: 10px;
		// 	height: 386px !important;
		// 	background-color: #fff;
		// 	padding-top: 20px;

		// 	.swiper-container {
		// 		width: 100%;
		// 		height: 100%;
		// 		margin-left: auto;
		// 		margin-right: auto;

		// 		.swiper-slide {
		// 			text-align: center;
		// 			font-size: 18px;
		// 			background: #fff;
		// 			height: calc((100% - 10px) / 2);
		// 			/*px*/

		// 			/* Center slide text vertically */
		// 			display: -webkit-box;
		// 			display: -ms-flexbox;
		// 			display: -webkit-flex;
		// 			display: flex;
		// 			-webkit-box-pack: center;
		// 			-ms-flex-pack: center;
		// 			-webkit-justify-content: center;
		// 			justify-content: center;
		// 			-webkit-box-align: center;
		// 			-ms-flex-align: center;
		// 			-webkit-align-items: center;
		// 			align-items: center;

		// 			.swiperImg {
		// 				position: relative;

		// 				img {
		// 					width: 120px;
		// 					height: 120px;
		// 					vertical-align: middle;
		// 				}
		// 			}

		// 			.typeName {
		// 				font-size: 28px;
		// 				/*px*/
		// 				overflow: hidden;
		// 				white-space: nowrap;
		// 				text-overflow: ellipsis;
		// 				line-height: 60px;
		// 				color: #3d3d3d;
		// 				text-align: center;
		// 			}
		// 		}
		// 		.swiper-slide:nth-child(6n) {
		// 			padding-right: 60px;
		// 		}
		// 	}
		// }
		// 热门标签
		.biaoqianList {
			text-align: left;
			padding-top: 10px;
			overflow: hidden;
			background-color: #fff;
			padding: 0 16px 110px;
			padding-top: 0;

			button {
				display: inline-block;
				width: calc((100vw - 72px) / 4);
				border-radius: 30px;
				padding: 5px 18px;
				border: 1px solid #fec6d5;
				/*no*/
				background-color: #fff8fa;
				color: #ff70a0;
				// float: left;
				margin-bottom: 20px;
				margin-right: 10px;
				font-size: 26px;
				/*px*/
			}

			button:nth-child(4n) {
				margin-right: 0;
			}
		}
	}
</style>
